// extracted by mini-css-extract-plugin
export default {"container":"Baa-z","tab":"Caa-z","selected":"Daa-z"};